import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Payment Term Name",
    "Payment Days",
    "Description",
    "Status",
    "Action"
  ];
  
  export const TABLE_DATA = [
    { id: 1, name: "Meters", days:"30 Days", description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, name: "Kilogram", days:"90 Days", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, name: "Kilometers", days:"180 Days", description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];

  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Payment Term Name": "payment_term_name",
    "Payment Days": "payment_days",
    "Description":"payment_term_desc",    
    "Status": "status",
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };